import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Loader2, MailCheck } from "lucide-react";
import api from "../api";
import { useLang } from "../context/LanguageContext";

const ForgotPassword = () => {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [devToken, setDevToken] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDevToken(data.devResetToken || "");
      setSent(true);
    } catch { setSent(true); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary/50 px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="flex flex-col items-center gap-2 mb-6">
          <img src="/lp-logo.webp" alt="LytePress" className="h-16 w-16 rounded-full border border-border shadow-sm" />
          <span className="text-xl font-extrabold text-foreground">LytePress</span>
        </Link>
        <div className="bg-card border border-border rounded-2xl shadow-xl p-8" data-testid="forgot-password-page">
          {sent ? (
            <div className="text-center">
              <span className="mx-auto mb-3 h-12 w-12 rounded-2xl bg-[#e7f6ec] dark:bg-[#16341f] flex items-center justify-center"><MailCheck size={24} className="text-[#16a34a]" /></span>
              <h1 className="text-2xl font-extrabold text-foreground">{t("fgt.checkYourEmail")}</h1>
              <p className="text-sm text-muted-foreground mt-2">{t("fgt.ifThatEmailIs")}</p>
              {devToken && (
                <div className="mt-4 text-left bg-secondary rounded-xl p-3">
                  <p className="text-xs text-muted-foreground mb-1">Preview mode (email not wired) — use this link:</p>
                  <Link to={`/reset-password?token=${devToken}`} data-testid="dev-reset-link" className="text-xs text-[#16a34a] font-semibold break-all hover:underline">/reset-password?token={devToken.slice(0, 24)}…</Link>
                </div>
              )}
              <Link to="/login" className="mt-6 inline-block text-sm font-semibold text-[#16a34a] hover:underline">← Back to login</Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-extrabold text-foreground text-center mb-1">{t("fgt.forgotYourPassword")}</h1>
              <p className="text-sm text-muted-foreground text-center mb-6">{t("fgt.enterYourEmailAnd")}</p>
              <form onSubmit={submit} className="space-y-4">
                <div className="flex items-center gap-3 border border-border rounded-xl px-4 py-3"><Mail size={18} className="text-muted-foreground" /><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full bg-transparent outline-none text-sm text-foreground" data-testid="forgot-email" /></div>
                <button disabled={loading} data-testid="forgot-submit" className="w-full bg-[#16a34a] hover:bg-[#15803d] disabled:opacity-60 text-white font-semibold py-3 rounded-xl transition-colors flex items-center justify-center gap-2">{loading && <Loader2 className="animate-spin" size={18} />} Send reset link</button>
              </form>
              <p className="mt-4 text-center text-sm text-muted-foreground">{t("fgt.rememberedIt")} <Link to="/login" className="text-[#16a34a] font-semibold hover:underline">{t("fgt.logIn")}</Link></p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
